import PropTypes from 'prop-types'
import React, { useState, useRef, useEffect } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardImg,
  CardTitle,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap"
import { Link } from "react-router-dom"
import Util from "./Common/Util"

import moment from 'moment';
import { useHistory } from 'react-router-dom';

// import images
import client from "../../assets/images/client.png";
import transactionAmount from "../../assets/images/transactionAmount.png";
import transactionPrice from "../../assets/images/transactionPrice.png";
import tradeHistory from "../../assets/images/거래내역.jpg";
import img1 from "../../assets/images/small/img-1.jpg"
import defaultImg from "../../assets/images/default.png"
import leftArrow from "assets/images/left_arrow.png"
import rightArrow from "assets/images/right_arrow.png"
import testbanner1 from "assets/images/testbanner1.png"
import testbanner2 from "assets/images/testbanner2.png"
import testbanner3 from "assets/images/testbanner3.png"

// Charts
import LineAreaChart from "../AllCharts/apex/lineareachart";
import ChartistGraph from 'react-chartist';

import "chartist/dist/scss/chartist.scss";

import { useSelector } from 'react-redux';

import { dashboardResponse, getAdvertisement, getProductList, mainResponse, newsResponse } from 'crud/auth.crud';

let autoPlay = true

const Dashboard = props => {
  const history = useHistory()
  const selector = useSelector(state => state)
  const newDate = new Date()
  const slide = useRef(null)
  const leftBar = useRef(null)
  const rightBar = useRef(null)

  const [isFetching, setIsFetching] = useState(false)
  const [isListEnd, setIsListEnd] = useState(false)
  const [page, setPage] = useState(1)
  const [companyCount, setCompanyCount] = useState();
  const [collectSum, setCollectSum] = useState();
  const [collectMoneySum, setCollectMoneySum] = useState();
  const [newsList, setNewsList] = useState();
  const [isRefresh, setIsRefresh] = useState(false)
  const [dataList, setDataList] = useState([])
  const [left, setLeft] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)
  const [adList, setAdList] = useState([])
  const [firstList, setFirstList] = useState([])    
  // const [autoPlay, setAutoPlay] = useState(true)

  // 지금 이 시간 웨이스트버스는? 가져오는 용
  const getDashboardData = async () => {
    const response = await dashboardResponse();    
    if(response.data?.result === 'success'){
      const item = response.data?.data
      setCompanyCount(Util.setAbbreviation(item.company_count));
      setCollectSum(Util.setAbbreviation(item.sum_collect));
      setCollectMoneySum(Util.setAbbreviation(item.sum_collect_money));
    }
  }

  // 웨이스트버스뉴스! 가져오는 용
  const getNewsList = async () => {
    try {
      const response = await newsResponse();
      if (response.status === 200) {        
        const tmpData = response.data?.results?.sort((a, b) => new Date(b.write_date).getTime() - new Date(a.write_date).getTime());
        const newsList = tmpData?.slice(0, 9).map(news => ({
          ...news,
          write_date: moment(new Date(news.write_date)).format('YYYY-MM-DD HH:mm:ss'),
          subject: Util.truncateString(Util.replaceHtmlTag(news.subject), 120),
          content: Util.truncateString(Util.replaceHtmlTag(news.content), 80),
        }));        
        setNewsList(newsList);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 상품목록 가져오는 용
  const getDataList = async () => {
    try {
      const response = await getProductList();
      if (response.status === 200) {
        setDataList(response.data?.results.splice(0, 6))
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 배너 리스트 가져오는 용
  const getBannerList = async () => {
    try {
      const response = await getAdvertisement();          
      if (response.status === 200) {
        let items = response.data.results
        let tmp = []
        for(let i=0; i<items.length; i++){
          let item = items[i];
          tmp.push( {url :  Util.addHostUrl(item?.advertisement_file?.[0]?.path || '')})
        }
        setFirstList(tmp)        
        getAdList('', tmp)
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getAdList = (direction, tmp) => {    
    let newList = tmp ? [...tmp] : [...firstList]    
    if(direction === 'left'){
      if (Array.isArray(firstList)) {                
        newList.unshift(newList.pop());              
        setFirstList([...newList])
      }  
    } else if (direction === 'right'){
      if (Array.isArray(firstList)) {                       
        newList.push(newList.shift());    
        setFirstList([...newList])
      }      
    }
    try {
      let newArr = []
      for(let i=0; i<newList.length; i++){
        let object = {
          url: newList[i]['url'],
          left: 100 * i
        }
        newArr.push(object)
      }
      setAdList(newArr)
    } catch (error) {
      console.error(error);
    }
  }

  const clickList = (item) => {
    // setDetailData({...item});
    const url = {
      pathname: `/sell-detail-screen`,
      state: { ...item }
    }
    history.push(url);
  }

  const slideAnimation = (direction) => {
    if(autoPlay){      
      autoPlay = false
      // setAutoPlay(false)
    }
    setIsAnimating(true)
    if (direction === 'left'){
      const left = slide.current;      
      let position = -100;
      const intervalId = setInterval(() => {
        position += 1;        
        left.style.left = `${position}%`;
        if (position >= 0) {
          left.style.left = '-100%'
          getAdList('left')
          clearInterval(intervalId);
          setIsAnimating(false)
        }
      }, 5);
    } else if (direction === 'right'){
      const left = slide.current;
      let position = -100;
      if(adList.length === 2){
        let ob = {url: adList[0]['url'], left: 200}
        setAdList([...adList, ob])
      }
      const intervalId = setInterval(() => {
        position -= 1;
        left.style.left = `${position}%`;
        if (position <= -200) {
          left.style.left = '-100%'
          getAdList('right')
          clearInterval(intervalId);
          setIsAnimating(false)
        }
      }, 5);
    }
  };

  const hoverAnimation = (direction) => {
    if (direction === 'left'){
      const left = leftBar.current;
      let opacity = 0
      const intervalId = setInterval(() => {
        opacity += 0.05;
        left.style.background = `linear-gradient(to left, rgba(0,0,0,0), rgba(0,0,0,${opacity}))`;
        if (opacity >= 0.5) {
          clearInterval(intervalId);
        }
      }, 15)
    } else if (direction === 'right'){
      const right = rightBar.current;
      let opacity = 0
      const intervalId = setInterval(() => {
        opacity += 0.05;
        right.style.background = `linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,${opacity}))`;
        if (opacity >= 0.5) {
          clearInterval(intervalId);
        }
      }, 15)
    }
  }

  const unhoverAnimation = (direction) => {
    if (direction === 'left'){
      const left = leftBar.current;
      let opacity = 0.5
      const intervalId = setInterval(() => {
        opacity -= 0.05;
        left.style.background = `linear-gradient(to left, rgba(0,0,0,0), rgba(0,0,0,${opacity}))`;
        if (opacity <= 0) {
          clearInterval(intervalId);
        }
      }, 15)
    } else if (direction === 'right'){
      const right = rightBar.current;
      let opacity = 0.5
      const intervalId = setInterval(() => {
        opacity -= 0.05;
        right.style.background = `linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,${opacity}))`;
        if (opacity <= 0) {
          clearInterval(intervalId);
        }
      }, 15)
    }
  }
  
  const slideAnimationAuto = (tmp) =>{                
            
      setIsAnimating(true)
      const left = slide.current;
      let position = -100;      
      const intervalId = setInterval( async () => {
        position -= 1;
        left.style.left = `${position}%`;
        if (position <= -200) {
          left.style.left = '-100%'          
          getAdList('right', tmp)
          clearInterval(intervalId);
          setIsAnimating(false)
        }
      }, 5);
    
  }

  useEffect(() => {
    getDataList();
    getDashboardData();
    getNewsList();
    // getAdList('');
    getBannerList()
    
  }, [])

  useEffect(()=>{
    const timeoutId = setTimeout(()=>{
      if(firstList && firstList.length > 0 && autoPlay){                  
        slideAnimationAuto([...firstList])
      }      
    },3000)

    return () => {
      clearTimeout(timeoutId)
    }
  },[firstList])

  return (
    // <React.Fragment>
    // <div className="page-content">
    //   <MetaTags>
    //     <title>홈 | 웨이스트버스</title>
    //   </MetaTags>
    //   <Container fluid>
    //     <div className="page-title-box">
    //       <Row className="align-items-center">
    //         <Col md={8}>
    //           <h6 className="page-title">관리 홈</h6>
    //           <ol className="breadcrumb m-0">
    //             <li className="breadcrumb-item active">'국내최초' 음식물류 폐기물 스마트 수거 플랫폼</li>
    //           </ol>
    //         </Col>

    //       </Row>
    //     </div>
    <>
      <Row>

        <Col xl={6} lg={12} style={{ marginBottom: '1.5rem', height: 304}}>
          <div style={{position: 'relative', width: '100%', height: '100%', overflow: 'hidden'}}>
          <div style={{display: adList.length < 2 ? 'none' : 'block', width: 72, height: '100%', position: 'absolute', backgroundColor: 'black', zIndex: 10, left: 0, top: 0, bottom: 0, margin: 'auto 0', cursor: 'pointer', background: 'linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,0))' }} ref={leftBar} onClick={()=>{
            isAnimating ? null : slideAnimation('left')
          }} onMouseEnter={()=>{hoverAnimation('left')}} onMouseLeave={()=>{unhoverAnimation('left')}}>
            <img style={{position: 'absolute', left: 12, top: 0, bottom: 0, margin: 'auto 0'}} src={leftArrow} />
          </div>
          <div style={{ position: 'absolute', width: `${100 * adList.length}%`, height: '100%', left: adList.length < 2 ? '0%' : '-100%' }} ref={slide}>
            {adList.length > 0 && adList.map((item, index)=>{
              return (
                <Card key={index} className='card' style={{ position: 'absolute', height: '100%', width: `calc(100% / ${adList.length})`, backgroundImage: `url(${item.url})`, backgroundPosition: 'center', backgroundSize: 'cover', left: `calc(${item.left / adList.length}%)` }}>
                </Card>
              )
            })}
          </div>
          <div style={{display: adList.length < 2 ? 'none' : 'block', width: 72, height: '100%', position: 'absolute', zIndex: 10, right: 0, top: 0, bottom: 0, margin: 'auto 0', cursor: 'pointer' }} ref={rightBar} onClick={()=>{
            isAnimating ? null : slideAnimation('right')
          }} onMouseEnter={()=>{hoverAnimation('right')}} onMouseLeave={()=>{unhoverAnimation('right')}}>
            <img style={{position: 'absolute', right: 12, top: 0, bottom: 0, margin: 'auto 0'}} src={rightArrow} />
          </div>
          </div>
        </Col>
        <Col xl={3} md={6}>
          <Card className="mini-stat text-white bg-primary" style={{height: '42.5%'}}>
            <CardBody>
              <div className="mb-4">
                <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                  
                </h5>
                <h4 className="fw-medium font-size-22 text-white">
                  지금 이 시간 웨이스트버스는?
                </h4>
              </div>
            </CardBody>
          </Card>
          <Card className="mini-stat text-black" style={{height: '42.5%'}}>
            <CardBody>
              <div className="mb-0">
                <div className="float-start mini-stat-img me-4" style={{backgroundColor: '#95DBD1'}}>  
                  <img src={transactionAmount} alt="" />
                </div>
                <h5 className="font-size-16 text-uppercase pt-3 text-black-50 text-end">
                  총 거래량
                </h5>
                <h4 className="fw-medium pt-3 font-size-24 text-end">
                  {collectSum}kg{" "}
                </h4>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={3} md={6}>
          <Card className="mini-stat text-black" style={{height: '42.5%'}}>
            <CardBody>
              <div className="mb-0">
                <div className="float-start mini-stat-img me-4" style={{backgroundColor: '#95DBD1'}}>
                  <img src={client} alt="" />
                </div>
                <h5 className="font-size-16 text-uppercase pt-3 text-black-50 text-end">
                  고객사 수
                </h5>
                <h4 className="fw-medium font-size-24 pt-3 text-end">
                  {companyCount}개{" "}
                </h4>
              </div>
            </CardBody>
          </Card>
          <Card className="mini-stat text-black" style={{height: '42.5%'}}>
            <CardBody>
              <div className="mb-0">
                <div className="float-start mini-stat-img me-4" style={{backgroundColor: '#95DBD1'}}>
                  <img src={transactionPrice} alt="" />
                </div>
                <h5 className="font-size-16 text-uppercase pt-4 text-black-50 text-end">
                  총 거래대금
                </h5>
                <h4 className="fw-medium pt-3 font-size-24 text-end">
                  {collectMoneySum}원{" "}
                </h4>
              </div>
            </CardBody>
          </Card>
        </Col>         

        <Container fluid>
          <div className="page-title-box pb-5 pt-0">
            <Row className="align-items-center">
              <Col md={12}>
                <h6 className="page-title">등록된 상품</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active text-primary" style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => { history.push('/exchange-platform') }}>+ 더 많은 상품 보기</li>
                </ol>
              </Col>
            </Row>
          </div>
        </Container>

        {dataList && dataList.map((item, index) => {
          return (
            <Col xl={2} md={4} sm={6} xs={12} key={index}>
              <Card style={{ overflow: 'hidden' }}>
                <CardImg style={{ height: 220 }} top className="img-fluid" src={"http://wasteverse.ropiklabs.com" + item.trade_file?.[0]?.path} onError={(e) => e.target.src = defaultImg} alt="" />
                <CardBody>
                  <CardTitle className="h4">{item.subject ? item.subject : ''}</CardTitle>
                  <p className="card-text noMargin">
                    {item.price_per_kg * item.qty}원
                  </p>
                  <p className="card-text">
                    {item.qty}kg
                  </p>
                  <button
                    // to="#"
                    onClick={() => { clickList(item) }}
                    className="btn btn-primary waves-effect waves-light"
                  >
                    상세보기
                  </button>
                </CardBody>
              </Card>
            </Col>
          )
        })}

      </Row>

      <div className="page-title-box" style={{ paddingTop: 0 }}>
        <Row className="align-items-center">
          <Col md={12}>
            <h6 className="page-title">웨이스트버스뉴스!</h6>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">음식물 배출 및 재생원료에 대한 정보를 얻어가세요.</li>
            </ol>
          </Col>
        </Row>
      </div>

      <Row>
            {newsList && newsList.map((item, index) => { return (
              <Col xl={4} md={6} key={index}>
              <a href={item.link} style={{color: '#5b626b'}} target="_blank">
                <Card className="directory-card">
                  <CardBody>
                    <div className="d-flex">
                      <img
                        src={item.image_url}
                        alt="사진"
                        className="img-fluid avatar-lg"
                        style={{width: 6.5 + 'rem', height: 5.5 + 'rem', borderRadius: '4px'}}
                        onError={(e) => e.target.src = defaultImg}
                      />
                      <div className="flex-1 ms-4">
                        <h5 className="font-size-18 mt-0 mb-1 text-black">
                        {item.subject}
                        </h5>
                        {/* <p className="font-size-12 mb-2">{item.created_at.substr(11, 8)}</p> */}
                        <p className="mb-0 text-end font-size-12" style={{position: 'absolute', bottom: '1rem', right: '1rem'}}>{Util.formatNewsTime(item.write_date)}</p>
                      </div>
                    </div>
                    {/* <hr /> */}
                    {/* <p className="mb-0">
                      <b>{item.content}</b>{" "}
                      <a href={item.link} target="_blank" className="text-primary">
                        {" "}
                        더 보기
                      </a>
                    </p> */}
                  </CardBody>
                </Card>
                </a>
              </Col>
            )})
            }
      </Row>
    </>
    //   </Container>
    // </div>

    // </React.Fragment>
  )
}

export default Dashboard
